interface IAnswerPillProps {
  answer: boolean | null;
}

/** Respuesta de la persona: SI / NO / sin respuesta */
export default function AnswerPill({ answer }: IAnswerPillProps) {
  if (answer === true) {
    return (
      <span className="pill pill--yes">
        <span className="pill__dot" />
        SI
      </span>
    );
  }

  if (answer === false) {
    return (
      <span className="pill pill--no">
        <span className="pill__dot" />
        NO
      </span>
    );
  }

  return (
    <span className="pill pill--pending">
      <span className="pill__dot" />
      Sin respuesta
    </span>
  );
}
